import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import { IconWarning } from '../easyclaim.app.assets/index';

import { FadeIn } from './animations/FadeIn';
import { FadeInBottom } from './animations/FadeInBottom';

interface MainErrorProps {
	message: JSX.Element;
}
export class MainError extends React.Component<MainErrorProps, {}> {
	render() {
		return (
			<Container>
				<StyledWarningIcon />
				<Message>{this.props.message}</Message>
				<button onClick={(e: any) => window.location.reload()}>
					<FormattedMessage id="mainError.tryAgain" />
				</button>
			</Container>
		);
	}
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
	animation: ${css`
			${FadeIn}`} 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
`;

const StyledWarningIcon = styled(IconWarning)`
	height: 4rem;
	margin: 0 auto 2rem auto;
	vertical-align: text-bottom;
	color: ${(p) => p.theme.colors.danger};
	animation: ${css`
			${FadeInBottom}`} 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
`;

const Message = styled.div`
	text-align: center;
	margin: 2rem 2rem 4rem 2rem;
`;
